import { Button, Modal } from "react-bootstrap";
import { ModalContentStyled } from "./styled/ModalsStyled";
import { createStructuredSelector } from "reselect";
import { getUserEmailSelector, makeSelectPasswordResetSent } from "../../app/appSelectors";
import { connect } from "react-redux";
import { passwordResetAction, passwordResetReset } from "../Login/loginActions";
import { useCallback, useEffect } from "react";
import { ResetPasswordModalButtonWrapper } from "./styled/ResetPasswordModalStyled";
import ResendCodeButton from "../Login/components/ResendCodeButton";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

export const ResetPasswordModal = (props) => {
    const {passwordReset, passwordResetReset, passwordResetSend, userEmail} = props;
    const {getLangPath} = useLangContext();

    useEffect(() => () => {
        passwordResetReset();
    }, [passwordResetReset])

    const handleResetPasswordClick = useCallback(() => {
        passwordReset({email: userEmail});
    }, [passwordReset, userEmail]);
    return (
            <>
                <Modal.Header closeButton>
                    {getLangPath(passwordResetSend ? 'reset_password.check_email' : 'reset_password.title')}
                </Modal.Header>
                <ModalContentStyled>
                    {
                        passwordResetSend ? (
                                <>
                                    <p>{getLangPath('reset_password.follow_link')}</p>
                                    <p className="mb-0">{getLangPath('reset_password.resend_email')} {getLangPath('reset_password.resend_link')}</p>
                                    <ResetPasswordModalButtonWrapper>
                                        <ResendCodeButton email={userEmail} requestType="reset" className="w-100"/>
                                    </ResetPasswordModalButtonWrapper>
                                </>

                        ) : (
                                <>
                                    <span dangerouslySetInnerHTML={{__html: getLangPath('reset_password.we_send_link', {email: userEmail})}}/>
                                    <ResetPasswordModalButtonWrapper>
                                        <Button variant="info" size="lg" onClick={handleResetPasswordClick}
                                                className="w-100">
                                            {getLangPath('reset_password.title')}
                                        </Button>
                                    </ResetPasswordModalButtonWrapper>
                                </>
                        )
                    }
                </ModalContentStyled>
            </>
    )
}

const mapStateToProps = createStructuredSelector({
    passwordResetSend: makeSelectPasswordResetSent(),
    userEmail: getUserEmailSelector,
});

const mapDispatchToProps = (dispatch) => ({
    passwordReset: (payload) => dispatch(passwordResetAction(payload)),
    passwordResetReset: (payload) => dispatch(passwordResetReset(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordModal);
